import React, { useState } from 'react';
import {
  Heart,
  MessageCircle,
  Send,
  Bookmark,
  Loader2,
} from 'lucide-react';
import { portfolioPosts } from '../data/mock';

const canvaEmbed = (designId, token) =>
  `https://www.canva.com/design/${designId}/${token}/view?embed`;

function PostCard({ post }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="ig-card w-full max-w-[340px] mx-auto">
      {/* Design do Canva (mostra as fotos reais, com nav própria do Canva) */}
      <div className="relative aspect-square bg-[#fafafa] overflow-hidden">
        {!loaded && (
          <div className="absolute inset-0 flex items-center justify-center bg-[#ececec] z-10">
            <Loader2
              size={26}
              className="text-[#8a8a8a] animate-spin"
              strokeWidth={1.4}
            />
          </div>
        )}
        <iframe
          src={canvaEmbed(post.designId, post.token)}
          title={`Post ${post.id}`}
          loading="lazy"
          allow="fullscreen; clipboard-write"
          allowFullScreen
          onLoad={() => setLoaded(true)}
          className="absolute inset-0 w-full h-full border-0"
        />

        {/* Contador de fotos (canto superior direito, estilo Instagram) */}
        <div className="pointer-events-none absolute top-2.5 right-2.5 text-[11px] font-medium text-white bg-black/60 backdrop-blur-sm rounded-full px-2 py-0.5 z-20">
          {post.slots} fotos
        </div>
      </div>

      {/* Barra de ações (visual do Instagram, sem cabeçalho e sem legenda) */}
      <div className="flex items-center justify-between px-3.5 py-3">
        <div className="flex items-center gap-3.5">
          <Heart size={22} className="text-[#262626]" />
          <MessageCircle size={22} className="text-[#262626]" />
          <Send size={22} className="text-[#262626]" />
        </div>
        <Bookmark size={22} className="text-[#262626]" />
      </div>
    </div>
  );
}

export default function PortfolioPosts() {
  return (
    <section
      id="portfolio-posts"
      className="py-24 lg:py-32 bg-[color:var(--cream-100)]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <h2 className="font-serif text-5xl md:text-6xl text-[color:var(--brown-900)]">
            Portfólio
          </h2>
          <h3 className="mt-6 font-serif italic text-4xl md:text-5xl text-[color:var(--brown-900)] leading-tight">
            <span className="underline-gold-lg">Posts Estáticos</span>
          </h3>
          <p className="mt-8 text-[color:var(--brown-900)]">
            <span className="underline-gold">Deslize dentro de cada post para ver todas as fotos.</span>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {portfolioPosts.map((post) => (
            <div key={post.id} className="flex flex-col items-center">
              <PostCard post={post} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
